module.exports = __webpack_public_path__ + "img/page4-2.43cd8f24.png";